<!-- TEMPLATE -->
<template>
  <div id="deanInputSelectDragDrop" class="dean-input-select-multi">
    <div class="row">
      <!--
        <div class="small-12 medium-12 large-12 hd-12 columns">
          <dean-input-select 
            :title="options.title" 
            :options="options.items"  
            @selected-value="addItem"
            fill-width>
          </dean-input-select>
        </div>
        -->
      <div class="small-12 medium-12 large-12 hd-12 columns">
        <div class="row">
          <div
            class="small-12 medium-6 large-6 hd-6 columns dropzone-container"
          >
            <div class="dropzone">
              <div class="dropzone-label">
                Toevoegen <span v-if="title != ''"> aan {{ title }}</span>
              </div>
              <dean-search-field
                name="searchInInactive"
                :columns="searchItems"
                @input="searchInInactive"
                @dql="searchInInactiveDql"
                @live-dql="searchInInactiveDql"
                >Zoeken in "Toevoegen"</dean-search-field
              >
              <draggable v-model="data.inactive" :options="{ group: 'users' }">
                <transition-group
                  class="selected-container"
                  name="fade"
                  mode="out-in"
                >
                  <span
                    class="selected-item"
                    v-for="(item, key) in data.inactive"
                    :key="item.id"
                    :id="key"
                  >
                    <dean-icon
                      class="selected-item-icon"
                      :glyph="moveIcon"
                      width="18"
                      height="18"
                    >
                    </dean-icon>
                    <span
                      class="selected-item-text"
                      @click="moveToActive(item.id)" >
                      <span class="selected-item-position">
                        {{
                          key +
                            1 +
                            (inactiveMeta.pageNumber - 1) *
                              inactiveMeta.itemsPerPage
                        }}
                      </span>
                      - {{ item.label }}
                    </span>
                    <dean-icon
                      @click.native="moveToActive(item.id)"
                      class="selected-item-icon selected-item-icon-action"
                      :glyph="plusIcon"
                      width="18"
                      height="18"
                    >
                    </dean-icon>
                  </span>
                </transition-group>
              </draggable>
              <div
                v-if="inactiveMeta.itemsPerPage <= 1000 && disablePagination == false"
                class="pagination">
                <dean-pagination
                  :current-page="inactiveMeta.pageNumber"
                  :total-items="inactiveMeta.totalResults"
                  :items-per-page="inactiveMeta.itemsPerPage"
                  :visible-pages="inactiveMeta.visiblePages"
                  @page-changed="inactivePaginationChanged"
                  @items-per-page="inactiveItemsPerPageChanged"
                >
                </dean-pagination>
              </div>
            </div>
          </div>
          <div
            class="small-12 medium-6 large-6 hd-6 columns dropzone-container"
          >
            <div class="dropzone">
              <div class="dropzone-label">
                Actief <span v-if="title != ''"> op {{ title }}</span>
              </div>
              <dean-search-field 
              name="searchInactive" 
              :columns="searchItems"
              @input="searchInActive"
              @dql="searchInActiveDql"
              @live-dql="searchInActiveDql"
                >Zoeken in "Actief"</dean-search-field
              >
              <draggable v-model="data.active" :options="{ group: 'users' }">
                <transition-group
                  class="selected-container"
                  name="fade"
                  mode="out-in"
                >
                  <span
                    class="selected-item"
                    v-for="(item, key) in data.active"
                    :key="item.id"
                    :id="key"
                  >
                    <dean-icon
                      class="selected-item-icon"
                      :glyph="moveIcon"
                      width="18"
                      height="18"
                    >
                    </dean-icon>
                    <span class="selected-item-text"
                      v-if="item.edit == false || item.edit == undefined"
                      @click="moveToInactive(item.id)">
                      <span class="selected-item-position">
                        {{
                          key +
                            1 +
                            (activeMeta.pageNumber - 1) *
                              activeMeta.itemsPerPage
                        }}
                      </span>
                      - {{ item.label }}
                    </span>
                    
                    <span class="selected-item-text"
                      v-if="item.edit == true"
                      @click="editItem(item)">
                      <span class="selected-item-position">
                        {{
                          key +
                            1 +
                            (activeMeta.pageNumber - 1) *
                              activeMeta.itemsPerPage
                        }}
                      </span>
                      - {{ item.label }}
                    </span>
                    <dean-tooltip v-if="item.edit == true">
                      <span class="activator" slot="activator">
                        <dean-icon
                          @click.native="editItem(item)"
                          class="selected-item-icon selected-item-icon-action"
                          :glyph="editIcon"
                          width="18"
                          height="18"
                        >
                        </dean-icon>
                      </span>
                      {{ editText }}
                    </dean-tooltip>
                    <dean-icon
                      @click.native="moveToInactive(item.id)"
                      class="selected-item-icon selected-item-icon-action"
                      :glyph="deleteIcon"
                      width="18"
                      height="18"
                    >
                    </dean-icon>
                  </span>
                </transition-group>
              </draggable>
              <div
                v-if="activeMeta.itemsPerPage <= 1000 && disablePagination == false" 
                class="pagination">
                <dean-pagination
                  :current-page="activeMeta.pageNumber"
                  :total-items="activeMeta.totalResults"
                  :items-per-page="activeMeta.itemsPerPage"
                  :visible-pages="activeMeta.visiblePages"
                  @page-changed="activePaginationChanged"
                  @items-per-page="activeItemsPerPageChanged"
                >
                </dean-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<!--     ondrop="drop(event)" ondragover="allowDrop(event)"> -->

<!-- SCRIPT -->
<script lang="ts">
// VUE
import Vue from 'vue';
import { Component, Prop, Emit, Watch } from 'vue-property-decorator';

// SVG
import closeIcon from '../svg/feather-icons/x.svg';
import moveIcon from '../svg/feather-icons/move.svg';
import deleteIcon from '../svg/feather-icons/x.svg';
import plusIcon from '../svg/feather-icons/plus.svg';
import trashIcon from '../svg/feather-icons/trash.svg';
import editIcon from '../svg/feather-icons/edit-3.svg';

import deanIcon from './deanIcon.vue';
import deanSectionDivider from './deanSectionDivider.vue';
import deanSearchField from './deanSearchField.vue';
import deanPagination from './deanPagination.vue';
import deanTooltip from './deanTooltip.vue';
import draggable from 'vuedraggable';

@Component({
  components: {
    deanSectionDivider,
    deanIcon,
    deanSearchField,
    deanPagination,
    draggable,
    deanTooltip
  }
})
export default class deanInputSelectMultiDragDrop extends Vue {
  // PROPS
  @Prop({ default: '' }) title!: string;
  @Prop({ default: editIcon }) editIcon!: object;
  @Prop({ default: "Wijzigen" }) editText!: string;
  @Prop({ default: false }) disablePagination: boolean;
  @Prop({ 
    default: () => {
      return {
      name: {
        sort: true,
        dql: 'name',
      },
    }}})searchItems!: any;

  @Prop({
    default: () => {
      return {
        pageNumber: 1,
        itemsPerPage: 1000,
        numberOfPages: 1,
        totalResults: 1,
        link: '',
        prevPage: '',
        nextPage: '',
        sort: '',
        dql: '',
        search: '',
      };
    }
  })
  activeMeta!: any;

  @Prop({
    default: () => {
      return {
        pageNumber: 1,
        itemsPerPage: 1000,
        numberOfPages: 1,
        totalResults: 1,
        visiblePages: 1,
        link: '',
        prevPage: '',
        nextPage: '',
        sort: '',
        dql: '',
        search: ''
      };
    }
  })
  inactiveMeta!: any;

  @Prop({
    default: () => {
      return [
        {
          id: 'loading1',
          label: 'Laden...'
        }
        /*
       {
        id: "Active1",
        label: "Actief 1"
      },
      {
        id: "Active2",
        label: "Actief 2"
      },
      {
        id: "Active3",
        label: "Actief 3"
      },
      {
        id: "Active4",
        label: "Actief 4"
      },
      {
        id: "Active5",
        label: "Actief 5"
      },
         {
        id: "Active6",
        label: "Actief 6"
      },
      {
        id: "Active7",
        label: "Actief 7"
      },
      {
        id: "Active8",
        label: "Actief 8"
      },
      {
        id: "Active9",
        label: "Actief 9"
      },
      {
        id: "Active10",
        label: "Actief 10"
      }
      */
      ];
    }
  })
  activeData!: Array<any>;

  @Prop({
    default: () => {
      return [
        {
          id: 'loading2',
          label: 'laden...'
        }
        /*
      {
        id: "Inactive1",
        label: "Inactief 1"
      },
      {
        id: "Inactive2",
        label: "Inactief 2"
      },
      {
        id: "Inactive3",
        label: "Inactief 3"
      },
      {
        id: "Inactive4",
        label: "Inactief 4"
      },
      {
        id: "Inactive5",
        label: "Inactief 5"
      },
         {
        id: "Inactive6",
        label: "Inactief 6"
      },
      {
        id: "Inactive7",
        label: "Inactief 7"
      },
      {
        id: "Inactive8",
        label: "Inactief 8"
      },
      {
        id: "Inactive9",
        label: "Inactief 9"
      },
      {
        id: "Inactive10",
        label: "Inactief 10"
      }
      */
      ];
    }
  })
  inactiveData!: Array<any>;

  // DATA
  moveIcon: object = moveIcon;
  closeIcon: object = closeIcon;
  deleteIcon: object = deleteIcon;
  plusIcon: object = plusIcon;
  trashIcon: object = trashIcon;

  activeDataString: string = JSON.stringify(this.activeData);
  inactiveDataString: string = JSON.stringify(this.inactiveData);

  data: any = {
    active: this.activeData,
    inactive: this.inactiveData
  };

  meta: any = {
    active: {
      pageNumber: 1,
      itemsPerPage: 10,
      numberOfPages: 1,
      totalResults: 1,
      visiblePages: 5,
      link: '',
      prevPage: '',
      nextPage: '',
      sort: '',
      dql: '',
      search: ''
    },
    inactive: {
      pageNumber: 1,
      itemsPerPage: 10,
      numberOfPages: 1,
      totalResults: 1,
      visiblePages: 5,
      link: '',
      prevPage: '',
      nextPage: '',
      sort: '',
      dql: '',
      search: ''
    }
  };

  dragging: boolean = false;
  activeDrag: string = '';

  // WATCH
  @Watch('activeMeta')
  activeMetaPropChanged() {
    console.log(this.activeMeta);
    this.meta.active = this.activeMeta;
  }

  @Watch('inactiveMeta')
  inactiveMetaPropChanged() {
    console.log(this.inactiveMeta);
    this.meta.inactive = this.inactiveMeta;
    console.log(this.meta.inactive);
  }

  @Watch('activeData')
  activePropChanged() {
    this.data.active = this.activeData;
    this.deleteDuplicate();
  }

  @Watch('inactiveData')
  inactivePropChanged() {
    console.log('inactiveData');
    this.data.inactive = this.inactiveData;
    this.deleteDuplicate();
    /*
    if (this.data.inactive.length < 1) {
      this.inactivePaginationChanged(this.inactiveMeta.pageNumber + 1)
    }
    */
  }

  // METHODS
  deleteDuplicate() {
    if (this.data.active.length >= 1) {
      console.log(this.data.active.length);
      for (let activeItem in this.data.active) {
        for (let inactiveItem in this.data.inactive) {
          if (
            this.data.inactive[inactiveItem].id ==
            this.data.active[activeItem].id
          ) {
            let index = this.data.inactive.indexOf(inactiveItem);
            this.data.inactive.splice(Number(inactiveItem), 1);
          }
        }
      }
    }
  }

  activePaginationChanged(pageNumber: number) {
    console.log('paginationChanged');
    this.meta.active.pageNumber = pageNumber;
    this.$emit('active-meta', this.meta);
  }

  activeItemsPerPageChanged(itemsPerPage: number) {
    console.log(itemsPerPage);
    this.meta.active.pageNumber = 1;
    this.meta.active.itemsPerPage = itemsPerPage;
    this.$emit('active-meta', this.meta);
  }

  inactivePaginationChanged(pageNumber: number) {
    console.log('paginationChanged');
    this.meta.inactive.pageNumber = pageNumber;
    this.$emit('inactive-meta', this.meta);
  }

  inactiveItemsPerPageChanged(itemsPerPage: number) {
    console.log(itemsPerPage);
    this.meta.inactive.pageNumber = 1;
    this.meta.inactive.itemsPerPage = itemsPerPage;
    this.$emit('inactive-meta', this.meta);
  }

  editItem(item: object){
    console.log(item);
    this.$emit('edit', item)
  }

  moveToInactive(id: string) {
    for (let key in this.data.active) {
      if (this.data.active[key].id == id) {
        this.data.inactive.push(this.data.active[key]);
        let index = this.data.active.indexOf(key);
        this.data.active.splice(Number(key), 1);
      }
    }
    this.$emit('data', this.data);
  }

  moveToActive(id: string) {
    for (let key in this.data.inactive) {
      if (this.data.inactive[key].id == id) {
        this.data.active.push(this.data.inactive[key]);
        let index = this.data.inactive.indexOf(key);
        this.data.inactive.splice(Number(key), 1);
      }
    }
    this.$emit('data', this.data);
  }

  searchInActive(value: string) {
    this.meta.active.pageNumber = 1;
    this.meta.active.search = value;
    this.$emit('active-meta', this.meta);
  }

  searchInActiveDql(value: string) {
    console.log(value)
    this.meta.active.pageNumber = 1;
    this.meta.active.dql = value;
    console.log(this.meta)
    this.$emit('active-meta', this.meta);
  }

  searchInInactive(value: string) {
    this.meta.inactive.pageNumber = 1;
    this.meta.inactive.search = value;
    this.$emit('inactive-meta', this.meta);
  }

  searchInInactiveDql(value: string) {
    console.log(value)
    this.meta.inactive.pageNumber = 1;
    this.meta.inactive.dql = value;
    console.log(this.meta)
    this.$emit('inactive-meta', this.meta);
  }

  mounted() {
    this.inactivePropChanged();
    this.activePropChanged();
    window.addEventListener('dragstart', event => {
      console.log('dragstart');
    });

    window.addEventListener('dragend', event => {
      console.log('dragend');
      this.$emit('data', this.data);
    });

    window.addEventListener('drag', event => {
      //console.log('drag')
    });
    this.$emit('data', this.data);
  }
}
</script>

<!-- STYLE -->
<style lang="scss" scoped>
// IMPORT
@import '../scss/vars';

// DEAN WIDGET
.dean-input-select-multi {
  position: relative;
  padding: 10px;

  .selected-container {
    display: block;
    padding: 5px 10px 10px 10px;
    min-height: 270px;
    max-height: 270px;
    overflow-y: auto;
    overflow-x: hidden;
    @media #{$medium} {
      min-height: 510px;
      max-height: 510px;
    }

    .selected-item {
      @include display-flex();
      justify-content: space-between;
      padding: 11px 10px 11px 10px;
      width: 100%;
      height: 40px;
      margin: 10px 0px 10px 0px;
      @include border-radius(100px);
      color: black;
      background: var(--color-light-shade-2, $color-light-shade-2);
      @include box-shadow(1px 1px 1px rgba(0, 0, 0, 0.15));
      cursor: move;
      user-select: none;

      .selected-item-text {
        width: 80%;
        padding-right: 10px;
        cursor: pointer;
        &:hover {
          color: var(--color-secondary, $color-secondary);
        }
      }

      .selected-item-position {
        font-weight: 700;
      }

      .selected-item-icon {
        fill: var(--color-link, $color-link);
        cursor: pointer;
        transition: 0.5s;
        &:hover {
          fill: var(--color-link-shade-2, $color-link-shade-2);
        }
      }
      .selected-item-icon-action {
        fill: var(--color-link, $color-link);
        &:hover {
          fill: var(--color-link-shade-2, $color-link-shade-2);
        }
      }
    }
  }
  .dropzone-container {
    position: relative;
    &:first-child {
      padding: 0px 0px 5px 0px;
    }
    &:last-child {
      padding: 5px 0px 0px 0px;
    }
    @media #{$medium} {
      &:first-child {
        padding: 0px 5px 0px 0px;
      }
      &:last-child {
        padding: 0px 0px 0px 5px;
      }
    }

    .dropzone {
      position: relative;
      width: 100%;
      height: 100%;
      background: white;
      @include border-radius(10px);
      @include transition(0.5s);
      padding-bottom: 10px;
      border: 1px solid var(--color-light-shade-2, $color-light-shade-2);

      .pagination {
        padding-top: 10px;
      }

      .dropzone-label {
        font-weight: 500;
        padding: 11px 10px 11px 10px;
        //border-bottom: 1px solid var(--color-light-shade-2, $color-light-shade-2);
        //color: white;
        background: var(--color-light-shade-2, $color-light-shade-2);
        @include border-radius(10px 10px 0px 0px);
      }
    }
  }
}
</style>
